import { getImage } from '@antv/l7-utils';
export default function image(data, cfg) {
  var _cfg$extent = cfg.extent,
      extent = _cfg$extent === void 0 ? [121.168, 30.2828, 121.384, 30.4219] : _cfg$extent;
  var images = new Promise(function (resolve) {
    loadData(data, function (res) {
      resolve(res);
    });
  });
  var resultData = {
    originData: data,
    images: images,
    _id: 1,
    dataArray: [{
      _id: 0,
      coordinates: [[extent[0], extent[1]], [extent[2], extent[3]]]
    }]
  };
  return resultData;
}

function loadData(data, done) {
  var url = data;
  var imageDatas = [];

  if (typeof url === 'string') {
    getImage({
      url: url
    }, function (err, img) {
      imageDatas.push(img);
      done(imageDatas);
    });
  } else {
    var imageCount = url.length;
    var imageindex = 0;
    url.forEach(function (item) {
      getImage({
        url: item
      }, function (err, img) {
        imageindex++;
        imageDatas.push(img);

        if (imageindex === imageCount) {
          done(imageDatas);
        }
      });
    });
  }

  return image;
}
//# sourceMappingURL=image.js.map